module.exports = {
    application_key: "Anwendungsschlüssel",
    network_key: "Netzwerkschlüssel",
    echo: "Echo-Intervall",
    alive: "Alive-Intervall",
    power_scale: "Leistungsskala",
    time_scale: "Zeitstrahl",
    active_channels: "aktive Kanäle",
    accuracy: "Richtigkeit",
    select_all: "Wählen Sie Alle",
    new_test_profile: "Neues Testprofil",
    new_group: "Neue Gruppe",
    energy_offset: "Energieversatz",
    transformation_ratio: "Transformationsverhältnis",
    add_tag: "Tag hinzufügen...",
    search: "Suche",
    number_of_rows: "Reihenanzahl",
    write_note: "Notiz schreiben",
    value: "Wert",
    security: "Sicherheit",
    IP_settings: "IP-Adresseinstellung",
    IP_address: "IP Adresse",
    network_mask: "Netzwerkmaske",
    gateway: "Tor",
    active_power_threshold: "Wirkleistungsschwelle",
    map_name: "Kartenname",
    group_name: "Gruppenname",
    device_select: "Geräteauswahl",
    relay_select: "Relais auswählen",
    notification_source: "Benachrichtigungstyp",
    notification_destination: "Platzierung der Benachrichtigung"
}